import React from 'react';

function Footer() {
  return (
    <footer className="footer">
      <div >
        <p> <a className="footer__content" href='https://pennmusa.github.io/MUSA_801.io/' >MUSA {new Date().getFullYear()}</a>
         <a className="footer__content" href='http://rebekahadams.com'>&copy; Rebekah Adams</a>
         <a className="footer__content">&copy; Aidan Rhianne</a> 
         <a className="footer__content" href='https://mintheworld.com/'>&copy; Minwook Kang</a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
